import { ColumnsType } from 'antd/es/table'
import { useParams } from 'react-router-dom'
import { useEffect, useMemo } from 'react'
import { useOriginalDocumentList } from '@/services/healthClaim/useOriginalDocumentList'
import {
  OriginalDocumentItem,
  OriginalDocumentStatus,
} from '@/services/healthClaim/useOriginalDocumentList/types'
import { toThaiLocaleDateDashAndTime } from '@/libs/date'
import { Space } from 'antd'
import { Dot } from './styles'

const SupportingDocumentsForClaimTabOriginalDocumentHook = () => {
  const { claimFormId } = useParams<{ claimFormId?: string }>()
  const {
    data: originalDocumentList,
    isLoading,
    error,
  } = useOriginalDocumentList(claimFormId || '')

  const getStatusTag = (status: OriginalDocumentStatus) => {
    switch (status) {
      case 'notReceivedOriginal':
        return 'ยังไม่ได้รับเอกสารฉบับจริง'
      case 'receivedOriginal':
        return 'ได้รับเอกสารฉบับจริงแล้ว'
      default:
        return '-'
    }
  }
  const columns: ColumnsType<OriginalDocumentItem> = [
    {
      title: 'ครั้งที่',
      width: 80,
      align: 'center',
      dataIndex: 'requestNo',
      key: 'requestNo',
    },
    {
      title: 'เอกสารที่ขอ',
      dataIndex: 'requestedDocuments',
      key: 'requestedDocuments',
      width: 500,
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      width: 220,
      render: (status: OriginalDocumentStatus) => (
        <Space>
          <Dot status={status} />
          {getStatusTag(status)}
        </Space>
      ),
    },
    {
      title: 'วันที่ SUBMIT FORM',
      dataIndex: 'submitFormAt',
      key: 'submitFormAt',
      align: 'center',
      width: 150,
      render: (date) => (date ? toThaiLocaleDateDashAndTime(date) : '-'),
    },
    {
      title: 'โทรศัพท์มือถือ',
      dataIndex: 'mobilePhone',
      key: 'mobilePhone',
      width: 120,
      align: 'center',
      render: (phone: string) => phone || '-',
    },
    {
      title: 'วันที่มีการส่ง SMS ทวงถาม',
      dataIndex: 'smsSentAt',
      key: 'smsSentAt',
      width: 150,
      align: 'center',
      render: (date) => (date ? toThaiLocaleDateDashAndTime(date) : '-'),
    },
    {
      title: 'วันที่ได้รับเอกสาร',
      dataIndex: 'documentReceivedAt',
      key: 'documentReceivedAt',
      width: 150,
      align: 'center',
      render: (date) => (date ? toThaiLocaleDateDashAndTime(date) : '-'),
    },
    {
      title: 'รับเอกสารโดย',
      dataIndex: 'receivedByName',
      key: 'receivedByName',
      width: 150,
      align: 'center',
      render: (receivedByName) => receivedByName || '-',
    },
  ]

  const tableData = useMemo(() => {
    if (!originalDocumentList) return []

    const dataWithRequestNo = originalDocumentList.map((item, index) => ({
      ...item,
      requestNo: originalDocumentList.length - index,
    }))
    return dataWithRequestNo
  }, [originalDocumentList])

  return {
    columns,
    tableData,
    isLoading,
    error,
    claimFormId,
  }
}

export default SupportingDocumentsForClaimTabOriginalDocumentHook
